import firebase from "firebase";

const config = {
  apiKey: "AIzaSyBRpUd3z2-nqcbn2_QuCpWdmD3aZOL2y2U",
  authDomain: "spirelab-agender.firebaseapp.com",
  databaseURL: "https://spirelab-agender.firebaseio.com",
  projectId: "spirelab-agender",
  storageBucket: "spirelab-agender.appspot.com",
  messagingSenderId: "622738803903",
  appId: "1:622738803903:web:1438a790332e58cbf94a0a",
  measurementId: "G-N54DJ9WPWE"
};

firebase.initializeApp(config);

export default firebase;
